export const SET_EXCEPTIONS = 'SET_EXCEPTIONS';
export const SET_EXCEPTION = 'SET_EXCEPTION';
export const ADD_EXCEPTION = 'ADD_EXCEPTION';
export const ADD_EXCEPTIONS = 'ADD_EXCEPTIONS';
export const UPDATE_EXCEPTION = 'UPDATE_EXCEPTION';
export const REMOVE_EXCEPTION = 'REMOVE_EXCEPTION';
export const CLEAR_EXCEPTION = 'CLEAR_EXCEPTION';
export const CLEAR_EXCEPTIONS = 'CLEAR_EXCEPTIONS';
